const { VUE_APP_API_BASE_URL, NODE_ENV = '' } = process.env;

const environment = NODE_ENV.toLowerCase();
const apiBaseUrl = VUE_APP_API_BASE_URL;

const hmisSettingsService = process.env.VUE_APP_HMIS_SETTINGS_URL;

const timeZoneOffset='+02:00'


export { environment, apiBaseUrl, hmisSettingsService, timeZoneOffset};
